var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStoreEnabledIcon = function SvgStoreEnabledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9V13V18C3 19.6569 4.34315 21 6 21H20C21.6569 21 23 19.6569 23 18V13V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H8C7.44772 12 7 12.4477 7 13V20C7 20.5523 7.44772 21 8 21H11C11.5523 21 12 20.5523 12 20V13C12 12.4477 11.5523 12 11 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H16C15.4477 12 15 12.4477 15 13V16C15 16.5523 15.4477 17 16 17H19C19.5523 17 20 16.5523 20 16V13C20 12.4477 19.5523 12 19 12Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9659 3.15869C23.3783 1.84541 22.0738 1 20.6351 1H18L18.9759 5.36217C18.9919 5.43384 18.9993 5.5071 19.002 5.58049C19.0299 6.336 19.3422 7.05481 19.8787 7.59132C20.4413 8.15393 21.2044 8.47 22 8.47C22.7956 8.47 23.5587 8.15393 24.1213 7.59132V7.59132C25.2196 6.493 24.6721 4.73712 24.0377 3.31931L23.9659 3.15869Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 1H12.98V5.47C12.98 6.26565 13.296 7.02871 13.8587 7.59132C14.4213 8.15393 15.1843 8.47 15.98 8.47C16.7756 8.47 17.5387 8.15393 18.1013 7.59132C18.6378 7.05481 18.9501 6.336 18.9779 5.58049C18.9806 5.5071 18.9719 5.43384 18.9559 5.36217L17.98 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95639 1C3.76618 1 2.68708 1.69937 2.20099 2.78579L1.96227 3.31932C1.32791 4.73713 0.78036 6.493 1.87868 7.59132C2.44129 8.15393 3.20435 8.47 4 8.47C4.79565 8.47 5.55871 8.15393 6.12132 7.59132C6.65783 7.05481 6.97015 6.336 6.99797 5.58049C7.00067 5.5071 7.00809 5.43384 7.02412 5.36217L8 1H4.95639Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1H8L7.02412 5.36217C7.00809 5.43384 6.99933 5.5071 7.00203 5.58049C7.02985 6.336 7.34216 7.05481 7.87868 7.59132C8.44129 8.15393 9.20435 8.47 10 8.47C10.7956 8.47 11.5587 8.15393 12.1213 7.59132C12.6839 7.02871 13 6.26565 13 5.47V1Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStoreEnabledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "1991699b9ec45a10c05bc4490d67320e.svg";